import { render, staticRenderFns } from "./SelectRealm.vue?vue&type=template&id=0cb6bd39&scoped=true&"
import script from "./SelectRealm.vue?vue&type=script&lang=ts&"
export * from "./SelectRealm.vue?vue&type=script&lang=ts&"
import style0 from "./SelectRealm.vue?vue&type=style&index=0&id=0cb6bd39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6bd39",
  null
  
)

export default component.exports